import { lazyPage } from '../../utils/lazyPage';

const MensCBBBestPicksToday = lazyPage(() => import('./BestPicksToday'));
const MensCBBmoneyline = lazyPage(() => import('./MensCBBmoneyline/MensCBBmoneyline'));
const MensCBBspread = lazyPage(() => import('./MensCBBspread/MensCBBspread'));
const MensCBBtotal = lazyPage(() => import('./MensCBBtotal/MensCBBtotal'));

const mensCBBRoutes = [
  {
    path: '/mens-cbb/best-picks-today',
    label: 'Best Edges Today',
    renderer: (params = {}) => <MensCBBBestPicksToday {...params} />,
    hidden: true
  },
  {
    path: '/mens-cbb/moneyline',
    label: 'Moneylines',
    renderer: (params = {}) => <MensCBBmoneyline {...params} />
  },
  {
    path: '/mens-cbb/spread',
    label: 'Spreads',
    renderer: (params = {}) => <MensCBBspread {...params} />
  },
  {
    path: '/mens-cbb/total',
    label: 'Totals',
    renderer: (params = {}) => <MensCBBtotal {...params} />
  }
];

export default mensCBBRoutes;
